import { __assign } from './../../../../external_lib/tslib/tslib.es6.js';
import React__default, { useContext } from 'react';
import Typography from '../../../../Atoms/Typography.js';
import LazyImage from '../../../../Atoms/LazyImage.js';
import CommaRoundedIcon from '../../../../assets/icons/comma-rounded.icon.js';
import { ThemeContext } from '../../../../provider.js';
import Icon from './../../../../external_lib/@ant-design/icons/es/components/Icon.js';

var backgroundImage = function (color) {
    return "\n<svg\n      width=\"336\"\n      height=\"203\"\n      viewBox=\"0 0 336 203\"\n      fill=\"none\"\n      xmlns=\"http://www.w3.org/2000/svg\"\n    >\n      <path\n        d=\"M0 31.7961C40.5 -39 221 111 336 0.0343018V203H0V31.7961Z\"\n        fill=\"".concat(color, "\"\n      />\n    </svg>\n").replace(/\n/g, '');
};
function TestimonialOneCard(_a) {
    var name = _a.name, quote = _a.quote, image = _a.image, designation = _a.designation, imageComponent = _a.imageComponent;
    var theme = useContext(ThemeContext).theme;
    var Comma = function (props) { return (React__default.createElement(Icon, __assign({ component: CommaRoundedIcon }, props))); };
    return (React__default.createElement("div", { className: "testimonial-one-card" },
        React__default.createElement(Typography, { variant: "bodyTextOne", classes: "testimonial-one-card__description" }, quote),
        React__default.createElement("div", { style: {
                backgroundImage: "url(\"data:image/svg+xml;utf8,".concat(encodeURIComponent(backgroundImage(theme.colors.primaryColor)), "\")")
            }, className: "testimonial-one-card__user" },
            React__default.createElement(LazyImage, { classes: "testimonial-one-card__image", src: image, imageComponent: imageComponent }),
            React__default.createElement(Typography, { variant: "headingOne", classes: "testimonial-one-card__name" }, name),
            React__default.createElement(Typography, { variant: "bodyTextOneMain", classes: "testimonial-one-card__designation" }, designation)),
        React__default.createElement("div", { className: "testimonial-one-card__commas__large" },
            React__default.createElement(Comma, { classes: "testimonial-one-card__comma__large" }),
            React__default.createElement(Comma, { classes: "testimonial-one-card__comma__large" })),
        React__default.createElement("div", { className: "testimonial-one-card__commas__small" },
            React__default.createElement(Comma, { classes: "testimonial-one-card__comma__small" }),
            React__default.createElement(Comma, { classes: "testimonial-one-card__comma__small" }))));
}

export { TestimonialOneCard as default };
//# sourceMappingURL=testimonial-one-card.component.js.map
